// extracted by mini-css-extract-plugin
export default {"clickable-element":"SvWFD","clickable-element-inline":"CKetJ","clickable-element-block":"byA9O"};